import { render } from "./ArrowDown.vue?vue&type=template&id=6acf6202"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArrowDown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6acf6202"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6acf6202', __exports__)) {
    api.reload('6acf6202', __exports__)
  }
  
  module.hot.accept("./ArrowDown.vue?vue&type=template&id=6acf6202", () => {
    api.rerender('6acf6202', render)
  })

}


export default __exports__